import { render, staticRenderFns } from "./GradeInputForm.vue?vue&type=template&id=00672617&scoped=true&"
import script from "./GradeInputForm.vue?vue&type=script&lang=js&"
export * from "./GradeInputForm.vue?vue&type=script&lang=js&"
import style0 from "./GradeInputForm.vue?vue&type=style&index=0&id=00672617&scoped=true&lang=css&"
import style1 from "./GradeInputForm.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00672617",
  null
  
)

export default component.exports